import React from 'react'
import { WContainer, Breadcrumbs, MainTitle, MainDescription } from '@next-nx/shared-ui/atoms'
import { StoreLocatorTabs, TextImageBox } from '@next-nx/shared-ui/organisms'
import { Page, StoreLocatorHelpBanner } from '@next-nx/shared-ui/organisms'
import styles from './StoreLocatorTemplate.module.sass'
import { useFindMenu, useTrans } from '@next-nx/hooks'
import IconTextDescriptionItem from '../../molecules/IconTextDescriptionItem/IconTextDescriptionItem'

interface Props {
  pagina?: any
  tabs?: any[]
}

const StoreLocatorTemplate = (props: Props) => {
  const { pagina = {}, tabs = [] } = props

  const t = useTrans()
  const helpBannerMenu = useFindMenu('help_banner')
  const helpBannerStoreLocatorMenu = useFindMenu(
    pagina.chiave === 'agenzie' ? 'help-banner-agenzie' : 'store-locator',
    helpBannerMenu
  )

  const agenzie = useFindMenu('pagina-agenzie')
  const agenzieServizi = useFindMenu('servizi-list', agenzie)
  const agenzieBanner = useFindMenu('banner-agenzie', agenzie)

  return (
    <Page pagina={pagina} className={`${styles.root}`}>
      <WContainer>
        <Breadcrumbs breadcrumbs={pagina.breadcrumbs} className={styles.breadcrumbs} />
        <MainTitle label={pagina.titolo} className={styles.title} />
        <MainDescription
          html={
            pagina.chiave === 'agenzie'
              ? t(
                  'Scopri l’elenco completo delle nostre agenzie per stipulare un contratto di noleggio.'
                )
              : pagina.descrizione
          }
          className={styles.descrizione}
        />
      </WContainer>
      <StoreLocatorTabs tabs={tabs} className={styles.form} />
      {pagina.chiave === 'agenzie' && (
        <WContainer>
          <MainDescription html={pagina.descrizione} className={styles.descrizione} />
        </WContainer>
      )}
      {pagina.chiave === 'agenzie' && agenzieServizi?.children?.edges.length && (
        <WContainer>
          {agenzieServizi.children.edges.map((x) => (
            <IconTextDescriptionItem item={x?.node} className={styles.IconTextDescriptionItem} />
          ))}
        </WContainer>
      )}
      {pagina.chiave === 'agenzie' && agenzieBanner && (
        <WContainer>
          <TextImageBox
            item={agenzieBanner}
            imagePos={'left'}
            titleSize={'md'}
            ctaVariant={'primary'}
            className={styles.bannerAgenzie}
          />
        </WContainer>
      )}
      {helpBannerStoreLocatorMenu && (
        <StoreLocatorHelpBanner item={helpBannerStoreLocatorMenu} className={styles.help} />
      )}
    </Page>
  )
}

export default StoreLocatorTemplate
